import { Flex, Text } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import BaseClickable from '@/components/ui/BaseClickable';
import MultiLineEllipsis from '@/components/ui/MultiLineEllipsis';

import s from './BaseItem.module.scss';

type Props = {
  className?: string;
  isActive: boolean;
  hasLineThrough?: boolean;
  withBottomLine?: boolean;
  actionSlot?: React.ReactNode;
  title: string;
  text?: React.ReactNode;
  note?: string;
  onClick: () => void;
};

const BaseItem: React.FC<Props> = ({
  className,
  isActive,
  hasLineThrough = false,
  withBottomLine = false,
  actionSlot,
  title,
  text,
  note,
  onClick,
}) => {
  const textDecoration = hasLineThrough ? 'line-through' : undefined;

  return (
    <BaseClickable
      className={cn(s.root, isActive && s.root_active, withBottomLine && isActive && s['root_active-line'], className)}
      onClick={onClick}
    >
      <Flex className={s.root__top} align="center" justify="space-between" gap="sm">
        {actionSlot}
      </Flex>
      <MultiLineEllipsis maxLine={2}>
        <Text className={s.root__title} td={textDecoration} size="md" lh="sm" fw={700}>
          {title}
        </Text>
      </MultiLineEllipsis>
      {text && (
        <Text component="div" className={s.root__text} td={textDecoration} size="xs" lh="xxs">
          {text}
        </Text>
      )}
      {note && (
        <MultiLineEllipsis maxLine={2} maw={300}>
          <Text className={s.root__note} size="xs" lh="xxs">
            {note}
          </Text>
        </MultiLineEllipsis>
      )}
    </BaseClickable>
  );
};

export default React.memo(BaseItem);
